const predefinedPatterns = [
  [], // solid
  [2, 2], // dots
  [1, 2], // fine dots
  [4, 4], // shorter dashes
  [3, 2, 2, 2], // fat dot dot
  [6, 2], // longer dashes
];

import { getBinaryDashDotPattern } from './binary-based-stroke-patterns';

export function getStrokePatternByIndex(index: number) {
  return index < predefinedPatterns.length
    ? predefinedPatterns[index]
    : getBinaryDashDotPattern(index - predefinedPatterns.length);
}
